import Service from "../../Services";

const Restaurant = {
  namespaced: true,
  state: {
    form: {
      id: "",
      branch_id: "",
      download_url_show: "",
      is_publish: true,
      description_th: "",
      description_en: "",
      image_url : '',
      image_url_show : '',
      restaurant_details: []
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        branch_id: "",
        download_url_show: "",
        is_publish: true,
        description_th: "",
        description_en: "",
        image_url : '',
        image_url_show : '',
        restaurant_details: []
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getRestaurant({ commit }, page) {
      return Service.RestaurantAPI.getRestaurant(page);
    },
    // eslint-disable-next-line no-unused-vars
    showRestaurant({ commit }, id) {
      return Service.RestaurantAPI.showRestaurant(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveRestaurant({ commit }, { id, data }) {
      if (id) {
        return Service.RestaurantAPI.updateRestaurant(id, data);
      } else {
        return Service.RestaurantAPI.createRestaurant(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteRestaurant({ commit }, id) {
      return Service.RestaurantAPI.deleteRestaurant(id);
    },
    setFormRestaurant({ commit }, res) {
      console.log(res);
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default Restaurant;
